import { DatalayerItem, TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import { DefaultLinkClickData } from '../../tracking-services/types';
import { AdobeTracking } from '../../tracking-services';

const defaultTracking = {
  event: 'tag_click',
  component_name: 'roche_tag',
};

export const trackTag = (tag: string, translatedTag: string): DatalayerItem => ({
  ...defaultTracking,
  value: translatedTag,
  additionalParameters: {
    original_tag: tag,
  },
});

const adobeTracking = {
  position: 'RocheTag',
  type: 'Tag',
  socialMedia: '',
  socialInteraction: '',
};

export const adobeTrackTag = (tag: string, tagUrl: string): DefaultLinkClickData => ({
  ...adobeTracking,
  innerText: tag,
  url: tagUrl,
});

export const handleTagClick = (tag: string, translatedTag: string, tagUrl: string): void => {
  TrackingService.push(trackTag(tag, translatedTag));
  AdobeTracking(adobeTrackTag(tag, tagUrl), 'defaultLinkClick');
};
